import React, { useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Button,
} from '@chakra-ui/react'
import { InputText, Form } from '../../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../../helpers';

function Create({ meCloseEdit, loadList, rs }) {



	const [formData, setFormData] = useState({
		name: rs.name,
		id: rs.id,
	});

	const FormSchema = Yup.object().shape({
		name: Yup.string().required('Required'),
	});

	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = values
		const url = `${process.env.REACT_APP_API_URL}/message-type/update`;
		await fetchWrapper.post(url, data)
		loadList()
		meCloseEdit();
		toast(`Record has been updated `, {
			type: "info"
		});
	}


	return (
		<Form
			enableReinitialize
			validationSchema={FormSchema}
			initialValues={formData}
			onSubmit={onSubmit}
		>
			<Box mb="10px">
				<InputText name="name" title="Name" inputProps={{ isRequired: true }}/>
			</Box>
			<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
				mb={4}
				type='submit'
			>
				Update Message Type
			</Button>
		</Form>
	)
}

export default Create;